import Layout from '@/components/layout/index.vue'

export default {
  path: 'bidmanagementpur',
  name: 'Bidmanagementpur',
  meta: {},
  component: Layout,
  redirect: { name: 'Bidmanagementpur.Mybidding' },
  children: [
    {
      path: 'mybidding',
      name: 'Bidmanagementpur.Mybidding',
      meta: {},
      component: () => import(/* webpackChunkName: "bidmanagementpur" */ '@/views/purchaser/bidmanagementpur/mybidding/index.ts')
    },
    {
      path: 'mybidding/add',
      name: 'Bidmanagementpur.Mybidding.Add',
      meta: { title: 'bidmanagementpur.mybidding.addTo', dep: 'Bidmanagementpur.Mybidding' },
      component: () => import(/* webpackChunkName: "bidmanagementpur" */ '@/views/purchaser/bidmanagementpur/mybidding/manage.vue')
    },
    {
      path: 'mybidding/modify/:id',
      name: 'Bidmanagementpur.Mybidding.Modify',
      meta: { title: 'bidmanagementpur.mybidding.modifyTo', dep: 'Bidmanagementpur.Mybidding' },
      component: () => import(/* webpackChunkName: "bidmanagementpur" */ '@/views/purchaser/bidmanagementpur/mybidding/manage.vue')
    },
    {
      path: 'mybidding/biddingmonitoring/:id',
      name: 'Bidmanagementpur.Mybidding.Biddingmonitoring',
      meta: { title: 'bidmanagementpur.biddingmonitoring.biddingmonitoring', dep: 'Bidmanagementpur.Mybidding' },
      component: () => import(/* webpackChunkName: "bidmanagementpur" */ '@/views/purchaser/bidmanagementpur/mybidding/biddingmonitoring/biddingmonitoring.vue')
    },
    {
      path: 'mybidding/resultsrelease/:id',
      name: 'Bidmanagementpur.Mybidding.Resultsrelease',
      meta: { title: 'bidmanagementpur.resultsrelease.resultsrelease', dep: 'Bidmanagementpur.Mybidding' },
      component: () => import(/* webpackChunkName: "bidmanagementpur" */ '@/views/purchaser/bidmanagementpur/mybidding/resultsrelease/resultsrelease.vue')
    },
    {
      path: 'mybidding/biddingresult/:id',
      name: 'Bidmanagementpur.Mybidding.Biddingresult',
      meta: { title: 'bidmanagementpur.biddingresult.biddingresult', dep: 'Bidmanagementpur.Mybidding' },
      component: () => import(/* webpackChunkName: "bidmanagementpur" */ '@/views/purchaser/bidmanagementpur/mybidding/biddingresult.vue')
    },
    {
      path: 'mybidding/viewresults/:id',
      name: 'Bidmanagementpur.Mybidding.Viewresults',
      meta: { title: 'bidmanagementpur.viewresults.viewresults', dep: 'Bidmanagementpur.Mybidding' },
      component: () => import(/* webpackChunkName: "bidmanagementpur" */ '@/views/purchaser/bidmanagementpur/mybidding/viewresults/viewresults.vue')
    },
    {
      path: 'biddingauditlist',
      name: 'Bidmanagementpur.Biddingauditlist',
      meta: {},
      component: () => import(/* webpackChunkName: "bidmanagementpur" */ '@/views/purchaser/bidmanagementpur/biddingauditlist/index.ts')
    }
  ]
}
